import React from "react";
import { Download } from "lucide-react";
import { PDFDownloadButton } from "./pdfInvoice";
import { Button } from "../ui/button";
import { format } from "date-fns";

interface DownloadButtonProps {
  formData: {
    company: any;
    selectedBuilding: any;
    rows: Array<{
      id: number;
      service?: string;
      quantity?: number;
      price?: number;
    }>;
    invoiceNum: string;
    unit?: string;
    unitSize?: string;
    customField?: string;
    createdAt?: Date;
    totalPrice: number;
  };
}

export const DownloadButton: React.FC<DownloadButtonProps> = ({ formData }) => {
  const formatInvoiceData = () => {
    // Ensure date is valid or use current date as fallback

    if (!formData.createdAt) {
      formData.createdAt = new Date();
    }

    const date = format(formData.createdAt, "PPP");

    return {
      company: {
        companyName: formData.company?.companyName || "",
        companyAddress: formData.company?.companyAddress || "",
        companyCity: formData.company?.companyCity || "",
        companyState: formData.company?.companyState || "",
        companyZip: formData.company?.companyZip || "",
        companyEmail: formData.company?.companyEmail || "",
        companyLogo: formData.company?.companyLogo || "",
      },
      customer: {
        name: formData.selectedBuilding?.buildingName || "",
        address: formData.selectedBuilding?.address || "",
        city: formData.selectedBuilding?.buildingCity || "",
        state: formData.selectedBuilding?.buildingState || "",
        zip: formData.selectedBuilding?.buildingZip || "",
        country: formData.selectedBuilding?.buildingCountry || "",
        letterId: formData.selectedBuilding?.letterIdBuilding || "",
      },
      invoice: {
        number: formData.invoiceNum?.toString().padStart(5, "0") || "00000",
        date: date,
        unit: formData.unit || "",
        size: formData.unitSize || "",
        customField: formData.customField,
        services: formData.rows.map((row) => ({
          service: row.service || "",
          quantity: row.quantity || undefined,
          price: row.price || 0,
        })),
        total: formData.totalPrice || 0,
      },
    };
  };

  const formattedData = formatInvoiceData();

  return (
    <Button className="w-full justify-start gap-2 bg-transparent text-zinc-900 hover:bg-gray-100">
      <Download className="h-4 w-4" />
      <PDFDownloadButton
        invoiceData={{ invoice: formattedData.invoice }}
        companyData={{ company: formattedData.company }}
        customerData={{ customer: formattedData.customer }}
      />
    </Button>
  );
};

export default DownloadButton;
